(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format((cents || 0) / 100);

  async function fetchCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }

  function renderCart(drawer, cart) {
    const items = drawer.querySelector('[data-cart-drawer-items]');
    const subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
    const progress = drawer.querySelector('[data-cart-shipping-progress]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (items) {
      if (!cart.items.length) items.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      else items.innerHTML = cart.items.map((item) => `<div class="cart-drawer__item">${item.image ? `<img src="${item.image}" alt="">` : ''}<div><a class="cart-drawer__item-title" href="${item.url}">${item.product_title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-meta">${item.variant_title}</div>` : ''}<div class="cart-drawer__item-meta">Qty ${item.quantity}</div></div><div class="cart-drawer__item-price">${money(item.final_line_price)}</div></div>`).join('');
    }
    if (progress && !progress.hidden) {
      const threshold = Number(progress.dataset.freeShippingThreshold || 0);
      const remaining = Math.max(0, threshold - cart.total_price);
      progress.textContent = remaining > 0 ? `${money(remaining)} away from free shipping` : 'You’ve reached free shipping.';
    }
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
  }

  async function openCartDrawer(cart) {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.classList.add('cart-drawer-open');
    try { renderCart(drawer, cart || await fetchCart()); } catch (_) {}
    drawer.querySelector('[data-cart-drawer-close]')?.focus();
  }

  function closeCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('cart-drawer-open');
  }

  const searchOverlay = () => document.querySelector('[data-search-overlay]');
  function openSearch() {
    const overlay = searchOverlay();
    if (!overlay) return;
    overlay.hidden = false;
    overlay.querySelector('[data-predictive-search-input]')?.focus();
  }
  function closeSearch() {
    const overlay = searchOverlay();
    if (!overlay) return;
    overlay.hidden = true;
    const results = overlay.querySelector('[data-predictive-search-results]');
    if (results) { results.hidden = true; results.innerHTML = ''; }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-close]')) { closeCartDrawer(); return; }
    if (event.target.closest('[data-cart-drawer-open]')) { event.preventDefault(); openCartDrawer(); return; }
    const cartLink = event.target.closest('.header-actions a[href*="/cart"]');
    if (cartLink && document.querySelector('[data-cart-drawer]')) { event.preventDefault(); openCartDrawer(); return; }
    if (event.target.closest('[data-search-overlay-close]')) { closeSearch(); return; }
    const searchLink = event.target.closest('.header-actions a[href*="/search"]');
    if (searchLink && searchOverlay()) { event.preventDefault(); openSearch(); }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { closeCartDrawer(); closeSearch(); }
  });

  let searchTimer;
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-predictive-search-input]');
    if (!input) return;
    const results = input.closest('[data-search-overlay]')?.querySelector('[data-predictive-search-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    const query = input.value.trim();
    if (query.length < 2) { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
    searchTimer = setTimeout(async () => {
      try {
        const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error();
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const rendered = html.querySelector('.predictive-search-results');
        results.innerHTML = rendered ? rendered.outerHTML : '';
        results.hidden = !rendered;
        input.setAttribute('aria-expanded', rendered ? 'true' : 'false');
      } catch (_) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    }, 180);
  });

  document.addEventListener('fallingleaf:cart-updated', (event) => {
    const cart = event.detail && event.detail.cart;
    if (document.body.dataset.openCartAfterQuickAdd === 'true' && event.detail?.source === 'quick-add') openCartDrawer(cart);
    else if (cart) {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && !drawer.hidden) renderCart(drawer, cart);
    }
  });
})();